import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center" }
const _hoisted_2 = { class: "font-extrabold text-lg" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "color-grey-5" }, "Laporan Verbal", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Lihat Detail ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-right text-xs font-extrabold" }, null, -1)

import Card from 'primevue/card'
import { onMounted, ref } from 'vue'
import InlineSvg from 'vue-inline-svg'
import apiUsecase from '@/usecase/apiUseCase'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardVerbal',
  setup(__props) {

const totalRecod = ref(0)

const initialize = () => {
  apiUsecase.get('transaction/v1/Verbal?verbalStatusList=13')
    .then(({ error, count }) => {
      if (!error) {
        totalRecod.value = count
      }
    })
}

onMounted(() => {
  initialize()
})

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_unref(Card), { class: "card-no-shadow" }, {
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(totalRecod.value) + " Verbal", 1),
          _createVNode(_unref(InlineSvg), {
            src: require('@/assets/img/icon/entypo-traffic-cone.svg')
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_RouterLink, {
            to: {
            name: 'verbal-report'
          },
            class: "color-blue-1 font-extrabold cursor-pointer"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})